import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { CoreModule } from '../core/core.module';
import { RouterModule } from '@angular/router';
import { SafePipeUrl } from './safe-url.pipe';
import { register } from 'swiper/element/bundle';
import { HomeHeaderComponent } from './home/components/home-header/home-header.component';
import { HomeHeroComponent } from './home/components/home-hero/home-hero.component';
import { HomeValorComponent } from './home/components/home-valor/home-valor.component';
import { HomePasosComponent } from './home/components/home-pasos/home-pasos.component';
import { HomeAliadosComponent } from './home/components/home-aliados/home-aliados.component';
import { HomeCuentaComponent } from './home/components/home-cuenta/home-cuenta.component';
import { HomeCuentaFormNaturalComponent } from './home/components/home-cuenta/home-cuenta-form-natural/home-cuenta-form-natural.component';
import { HomeCuentaFormJuridicaComponent } from './home/components/home-cuenta/home-cuenta-form-juridica/home-cuenta-form-juridica.component';
import { HomeCuentaFormFooterComponent } from './home/components/home-cuenta/home-cuenta-form-footer/home-cuenta-form-footer.component';
import { HomeDatosComponent } from './home/components/home-datos/home-datos.component';
import { HomeTestimoniosComponent } from './home/components/home-testimonios/home-testimonios.component';
import { HomeSegmentacionComponent } from './home/components/home-segmentacion/home-segmentacion.component';
import { HomeParaMiComponent } from './home/components/home-para-mi/home-para-mi.component';
import { HomeFaqComponent } from './home/components/home-faq/home-faq.component';
import { HomeCtaFinalComponent } from './home/components/home-cta-final/home-cta-final.component';
import { HomeSiteFooterComponent } from './home/components/home-site-footer/home-site-footer.component';

// Inicializas Swiper
register();

@NgModule({
  declarations: [
    HomeComponent,
    SafePipeUrl,
    HomeHeaderComponent,
    HomeHeroComponent,
    HomeValorComponent,
    HomePasosComponent,
    HomeAliadosComponent,
    HomeCuentaComponent,
    HomeDatosComponent,
    HomeTestimoniosComponent,
    HomeSegmentacionComponent,
    HomeParaMiComponent,
    HomeFaqComponent,
    HomeCtaFinalComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CoreModule,
    RouterModule,
    HomeCuentaFormNaturalComponent,
    HomeCuentaFormJuridicaComponent,
    HomeCuentaFormFooterComponent,
    HomeSiteFooterComponent,
  ],
  exports: [
    HomeComponent,
    SafePipeUrl,
    HomeSiteFooterComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PageModule { }
